import React from "react";
import "./ProposalCoursesSelectEditing.scss";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import InputBorderModal from "../Forms/Inputs/InputBorderModal";
import SelectOptionSingle from "../Forms/Inputs/SelectOptionSingle";
import {
  removeUpdatingCourseAdded,
  updateCourseSelected,
} from "../../actions/proposal";
import { closeModal } from "../../actions/ui";
import { getDateAfter, getDateBefore } from "../../helper/dateConvertor";

const ProposalCoursesSelectEditing = () => {
  const courseToUpdate = useSelector((state) => state.proposals.courseToUpdate);
  const { courses } = useSelector((state) => state.courses);


  const dispatch = useDispatch();

  // Debe ser un hook o helper
  const courseCampus = () => {
    const course = courses.filter(
      (el) => el.college.name === courseToUpdate.college.name
    );
    return course[0]?.campus;
  };

  const campusFromCourse = courseCampus();

  const {
    name,
    college,
    //Price
    tuitionfee,
    applicationfee,
    material,
    firstPayment,
    dateFirstPayment,
    //Details
    duration,
    startDate,
    endDate,
    campus,
  } = courseToUpdate;

  const initialValues = {
    tuitionfee: tuitionfee,
    applicationfee: applicationfee,
    material: material,
    firstPayment: firstPayment,
    dateFirstPayment: dateFirstPayment,
    //
    duration: duration,
    startDate: startDate,
    endDate: endDate,
    campus: campus,
  };

  const dateAfter = getDateAfter(26);
  const dateDayBefore = getDateBefore(0.15);
  const dateSixAfter = getDateAfter();

  const courseSchema = Yup.object().shape({
    duration: Yup.number()
      .required("Duration Required")
      .min(1, "Invalid Number"),
    campus: Yup.string().required("Campus Required"),
    startDate: Yup.date()
      .required("Date Required")
      .min(dateDayBefore, "Date must be later")
      .max(dateSixAfter, "Date must be earlier"),
    endDate: Yup.date()
      .required("Date Required")
      .min(dateDayBefore, "Date must be later")
      .max(dateSixAfter, "Date must be earlier"),
    tuitionfee: Yup.number()
      .required("Tuition Required")
      .min(0, "Invalid Number"),

    applicationfee: Yup.number()
      .required("Application Required")
      .min(0, "Invalid Number"),

    material: Yup.number()
      .required("Material Required")
      .min(0, "Invalid Number"),
    firstPayment: Yup.number()
      .required("Payment Required")
      .min(0, "Invalid Number"),
    dateFirstPayment: Yup.date()
      .required("Date Required")
      .max(dateAfter, "Date must be earlier")
      .min(new Date(), "Date must be later"),
  });

  const handleFormikSubmit = (values) => {
    const total = {
      total: values.tuitionfee + values.applicationfee + values.material, // no los initial values
    };

    const courseUpdateInProposal = {
      ...courseToUpdate,
      ...values,
      ...total,
    };

    console.log(courseUpdateInProposal, "completo");

    dispatch(updateCourseSelected(courseUpdateInProposal));
    dispatch(removeUpdatingCourseAdded());
    dispatch(closeModal());
  };

  return (
    <div className="course-select-editing">

      
      <div className="course-select-editing__wrapper">
        <div className="course-select-editing__heading">
          <h2 className="title-gray-bold-16">{name}</h2>
          <h2 className="title-gray-reg-12">Powered by {college.name}</h2>
        </div>

        <Formik
          initialValues={initialValues}
          onSubmit={handleFormikSubmit}
          validationSchema={courseSchema}
          enableReinitialize
        >
          {({ values }) => {
            const { tuitionfee, applicationfee, material } = values;
            const total = tuitionfee + applicationfee + material;
           
            return (
              <Form>
                <div className="course-select-editing__body">
                  <div className="editing-body__wrapper">
                    <div className="course-select-editing__body--price">
                      <InputBorderModal
                        name="tuitionfee"
                        type="number"
                        label={"Tuition fee"}
                      />
                      <InputBorderModal
                        name="applicationfee"
                        type="number"
                        label={"Application fee"}
                      />
                      <InputBorderModal
                        name="material"
                        type="number"
                        label={`Material`}
                      />
                      <InputBorderModal
                        name="firstPayment"
                        type="number"
                        label={`First Payment`}
                      />
                      <InputBorderModal
                        name="dateFirstPayment"
                        type="date"
                        label={`Date First Payment`}
                      />
                    </div>
                    <div className="course-select-editing__body--detalles">
                      <SelectOptionSingle
                        label={`Campus`}
                        name="campus"
                        options={campusFromCourse}
                      />
                      <InputBorderModal
                        name="duration"
                        type="number"
                        label={`Duration(weeks)`}
                      />

                      <InputBorderModal
                        name="startDate"
                        type="date"
                        label={`Start Date`}
                      />

                      <InputBorderModal
                        name="endDate"
                        type="date"
                        label={`End Date`}
                      />
                    </div>
                  </div>
                  <div className="course-select-editing__total">
                    <h2 className="title-gray-bold-26">$A {parseFloat(total)}</h2>
                  </div>

                  <div className="course-select-editing__button">
                    <button className="btn-primary" type="submit">
                      Update
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default ProposalCoursesSelectEditing;
